import type { ReviewSnapshot } from "../../../components/CarrierReviews/reducer";
import type DealModel from "../../../viewModels/Deal/DealModel";

export const getCarrierReviewSnapshot = (deal: DealModel): ReviewSnapshot => ({
  dealId: deal.id,
  companyId: deal.companyId,
  status: deal.status,
  logisticianId: deal.logistician?.id,
  carrierIds: [
    ...new Set(deal.vehicles.map((vehicle) => vehicle.carrierId).filter((carrierId): carrierId is number => carrierId != null)),
  ].sort((a, b) => a - b),
  special: deal.financialScope === "SPECIAL",
  observer: Boolean(deal.observerOnly),
});
